module.exports = __webpack_public_path__ + "static/media/Tobeaccepted2.68af2c3e.png";